import {
  StaffActivitiesByDescription,
  StaffActivityDetails,
} from "../../types";

const DE_STATE_PORTAL_BASE: StaffActivityDetails = {
  parameters: {
    linkUrls: ["https://tierii.dnrec.delaware.gov/Account/Login.aspx"],
    staffInputs: {
      documentTypes: {
        report: true,
      },
    },
  },
  jurisdictionType: "State",
  activityType: "Portal",
  state: "DE",
};

export const staffActivities: StaffActivitiesByDescription = {
  "Delaware State Portal": {
    ...DE_STATE_PORTAL_BASE,
    parameters: {
      ...DE_STATE_PORTAL_BASE.parameters,
      staffInputs: {
        ...DE_STATE_PORTAL_BASE.parameters.staffInputs,
        fees: true,
        documentTypes: {
          ...DE_STATE_PORTAL_BASE.parameters.staffInputs?.documentTypes,
          invoice: true,
          receipt: true,
        },
      },
    },
  },
  "Delaware State Portal - Revision": {
    ...DE_STATE_PORTAL_BASE,
    parameters: {
      ...DE_STATE_PORTAL_BASE.parameters,
      staffInputs: {
        ...DE_STATE_PORTAL_BASE.parameters.staffInputs,
        fees: false,
      },
    },
  },
};
